<mat-accordion class="print-page">
  <h3 class="spacing--margin-left">{{ cultivationTitle }}</h3>
  @for (groupedCropField of mainGroupedCropFields$ | async; track groupedCropField) {
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ groupedCropField.cropName }}
          ({{ groupedCropField.cropFields.length }}
          {{ (groupedCropField.cropFields.length > 1 ? 'fields' : 'field') | translate }},
          {{ groupedCropField.totalHectares | agrNumber }} ha)
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ul data-test="registration-cropfield-list">
        @for (cropField of groupedCropField.cropFields; track cropField) {
          <li data-test="cropfields-overview-item">
            {{ cropField.name }} ({{ cropField.areaInHectares | agrNumber }} ha)
          </li>
        }
      </ul>
    </mat-expansion-panel>
  }

  <h3 class="spacing--margin-left">{{ subsequentCultivationTitle }}</h3>
  @for (groupedCropField of subsequentGroupedCropFields$ | async; track groupedCropField) {
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ groupedCropField.cropName }}
          ({{ groupedCropField.cropFields.length }}
          {{ (groupedCropField.cropFields.length > 1 ? 'fields' : 'field') | translate }},
          {{ groupedCropField.totalHectares | agrNumber }} ha)
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ul data-test="registration-cropfield-list">
        @for (cropField of groupedCropField.cropFields; track cropField) {
          <li data-test="cropfields-overview-item">
            {{ cropField.name }} ({{ cropField.areaInHectares | agrNumber }} ha)
          </li>
        }
      </ul>
    </mat-expansion-panel>
  }
</mat-accordion>
